import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'lib-progress-bar',
  templateUrl: './lib-progress-bar.component.html',
  styleUrls: ['./lib-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LibProgressBarComponent implements OnInit, OnChanges {
  @Input() progressValue = 0;
  @Input() maxValue = 1;
  @Input() displayPercent? = false;
  @Input() customText: string;
  @Input() customBGColor: string;
  @Input() customTextColor: string;

  progressPercentageValue = 0;
  progressPercentageString = '0%';
  customProgressClass = '';

  @ViewChild('progressBar') progressBarElement: ElementRef;
  @ViewChild('percentWrapper') percentWrapperElement: ElementRef;

  constructor(private cd: ChangeDetectorRef) {
    fromEvent(window, 'resize')
      .pipe(debounceTime(500))
      .subscribe(() => {
        this.cd.detectChanges();
      });
  }

  ngOnInit() {
    this.setValues();
    this.cd.detectChanges();
  }

  ngOnChanges() {
    this.setValues();
    this.cd.detectChanges();
  }

  setValues() {
    this.progressPercentageValue = this.progressPercentage();
    this.progressPercentageString = `${this.progressPercentageValue}%`;
    this.customProgressClass = this.setProgressClass();
  }

  progressPercentage(): number {
    return Math.round((this.progressValue / this.maxValue) * 100);
  }

  setProgressClass(): string {
    const lowerBound = 0;
    const upperBound = 100;
    let className: string;

    if (this.customText || this.progressValue === 0) {
      this.progressPercentageString = '100%';
      return;
    }

    if (this.progressPercentageValue < lowerBound) {
      // low
      className = 'bg-danger';
    } else if (this.progressPercentageValue >= upperBound) {
      // high
      className = 'bg-success';
    } else {
      // medium
      className = 'bg-warning';
    }

    return className;
  }

  get showPercentInBar(): boolean {
    const progressSpanElement = this.percentWrapperElement?.nativeElement?.querySelector('span');
    return this.progressBarElement?.nativeElement?.offsetWidth > progressSpanElement?.offsetWidth;
  }
}
